export default __webpack_public_path__ + "static/media/bgMain.b4019e1f.png";